module.exports = __webpack_public_path__ + "static/media/royalbro.033f9f84.pdf";